module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/hedge-trimming/size-3-958d97732e943ab367601812b877a895.svg";